import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IAthleteRoleGroup } from '@interfaces/lookups';
import { handleGetAthleteRoleGroups } from '@store/features/athleteRoleGroups/actions';
import {
  athleteRoleGroupsErrorSelector,
  athleteRoleGroupsIsLoadingSelector,
  athleteRoleGroupsIsReadySelector,
  athleteRoleGroupsSelector,
} from '@store/features/athleteRoleGroups/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useAthleteRoleGroups = (): IAthleteRoleGroup[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(athleteRoleGroupsSelector);
  const isLoading = useSelector(athleteRoleGroupsIsLoadingSelector);
  const isReady = useSelector(athleteRoleGroupsIsReadySelector);
  const error = useSelector(athleteRoleGroupsErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetAthleteRoleGroups());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.athleteRoleGroupsError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useAthleteRoleGroups);
